/* 共通｜SNSボタン ポップアップ --------------------------------- */
export function WinSnsOpen(src) {
    let l_pst = Number((window.screen.width - 550) / 2);
    let t_pst = Number((window.screen.height - 400) / 2);
    let wo = window.open(
        src,
        "_blank",
        "toolbar=no,location=no,directories=no,status=yes,menubar=no,scrollbars=yes,resizable=yes,width=550,height=450,left=" +
            l_pst +
            ",top=" +
            t_pst,
    );
    wo.window.focus();
}

export function bindSNSEvent() {
    const url = "https://colopl.co.jp/shironekoproject/lp/frontier/ep06/";
    // const hash = encodeURIComponent("#はっしゅたぐ");
    const text =
        encodeURIComponent(`神域のフロンティア編 第６章 FLOWSKY:INNOCENCE -後章-｜白猫プロジェクト NEW WORLD’S
${url} #白猫プロジェクト`);

    const twBtnArray = [].slice.call(document.querySelectorAll(".js-btnShare"));

    twBtnArray.forEach((e) => {
        e.addEventListener("click", function (e) {
            e.preventDefault();

            WinSnsOpen(`http://x.com/intent/post?text=${text}`);
        });
    });

    // document.querySelector(".tw").addEventListener("click", function (e) {
    //   e.preventDefault();

    //   WinSnsOpen(
    //     `http://twitter.com/intent/tweet?text=${text}%0a${url}%0a%0a${hash}`
    //   );
    // });

    // document.querySelector(".fb").addEventListener("click", function (e) {
    //   e.preventDefault();

    //   WinSnsOpen(`http://www.facebook.com/sharer.php?u=${url}&amp;t=${text}`);
    // });

    // document.querySelector(".li").addEventListener("click", function (e) {
    //   e.preventDefault();

    //   WinSnsOpen(`https://line.me/R/msg/text/?${text}%0a${url}`);
    // });
}
